<script>
  export let value;
  export let min = 0;
  export let max = 100000;

  const formatMoney = number => number.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0, minimumFractionDigits: 0 });

</script>

<input
  class="cl-slider w-full h-1 bg-primary-400 rounded-sm text-sm mt-4"
  type="range"
  min={min}
  max={max}
  bind:value={value}
/>
<div class="flex items-center justify-between w-full mt-3">
  <div class="text-xs font-normal text-neutral-100">{formatMoney(min)}</div>
  <div class="text-xs font-normal text-neutral-100">{formatMoney(max)}+</div>
</div>

<style>
  .cl-slider {
    -webkit-appearance: none;
    appearance: none;
  }
  .cl-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: #16B3FF;
    cursor: pointer;
    border-color: #fff;
    width: 18px;
    height: 18px;
    border-width: 4px;
    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
    border-radius: 100%;
  }
  .cl-slider::-moz-range-thumb {
    background: #16B3FF;
    cursor: pointer;
    border-color: #fff;
    border-width: 4px;
    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
    border-radius: 100%;
  }
</style>